import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import SimpleReactValidator from "simple-react-validator";
import {toast} from "react-toastify";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Link, useNavigate} from "react-router-dom";

import './style.scss';

const ForgotPassword = (props) => {
    document.title = "Recuperar Acesso :: WC Portáteis - Luís Silvestre Unipessoal, Lda. | Urinóis, Lava Mãos, Contentores WC, Eventos, Obras, Agricultura";
    const push = useNavigate()

    const [value, setValue] = useState({
        email: '',
    });

    const changeHandler = (e) => {
        setValue({...value, [e.target.name]: e.target.value});
        validator.showMessages();
    };

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const submitForm = (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setValue({
                email: '',
            });
            validator.hideMessages();
            push('/contact');
        } else {
            validator.showMessages();
            toast.error('Preencha o campo do NIF (Número de Identificação Fiscal)');
        }
    };
    return (
        <Grid className="loginWrapper">

            <Grid className="loginForm">
                <h2>Recuperar Acesso</h2>
                <p>Indique-nos o seu NIF e caso exista conta criada, receberá no seu e-mail as indicações de como aceder.</p>
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="NIF (Número de Identificação Fiscal)"
                                value={value.nif}
                                variant="outlined"
                                name="nif"
                                label="NIF"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('nif', value.nif, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formFooter">
                                <Button fullWidth className="cBtn cBtnLarge cBtnTheme" disabled="disabled">Recuperar Acesso</Button>
                            </Grid>
                            <p className="noteHelp">Já me recordo, voltar para a página de<Link to="/login">Acesso</Link>
                            </p>
                            <p className="noteHelp">Voltar ao<Link to="/">WC Portáteis</Link></p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                    <i className="fi flaticon-honeycomb"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default ForgotPassword;